const raw = `gigs-by-artist,gigs-by-venue,gigs-by-city{width:100%}`;
export default raw;